





























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SettingsState } from '@/store';
import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LPolyline,
} from 'vue2-leaflet';
import { MapOptions, latLng, LatLng, Icon } from 'leaflet';
import { MapMarker } from '@/dto';

// fix for default icon
type D = Icon.Default & {
    _getIconUrl: string;
};
delete (Icon.Default.prototype as D)._getIconUrl;

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup,
        LPolyline,
    },
})
export default class MapComponent extends Vue {
    // Chart data
    @Prop({ default: () => [] }) public channels!: any[];
    @Prop({ default: () => [] }) public vehicleMarkers!: MapMarker[];
    @Prop({ default: () => [] }) public siteMarkers!: MapMarker[];
    @Prop({ default: latLng(0, 0) }) public center!: LatLng;

    public zoom: number = 5;
    public channelColor = '#5D90FC';
    public pathColor = '#ea2448';
    public url: string = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

    public mapOptions: MapOptions = {
        zoomControl: false,
        trackResize: true
    };

    public refresh() {
        window.dispatchEvent(new Event('resize'));
    }

    private get iconSizeMultiplier() {
        return SettingsState.contextSettings.global.siteIconSizeMultiplier || 1;
    }

    private size(multiple?: number) {
        const iconSVGSize: number = 40;
        const iconSizeMultiplier: number = Number(this.iconSizeMultiplier);
        const size: number = iconSVGSize * iconSizeMultiplier * (multiple ?? 1);

        let style = `height: ${size.toString()}px; width: ${size.toString()}px;`;

        style = `${style};
                position: absolute;
                left: -${size / 2 - 4}px;
                top: -${size / 2 - 4}px;`;
        return style;
    }

    private arrowStyle(path: LatLng[], i: number) {
        let style = `${this.size(0.5)} fill: ${this.pathColor};`;
        if (i > 0) {
            const p1 = path[i - 1];
            const p2 = path[i];
            const angle =
                (Math.atan2(p2.lng - p1.lng, p2.lat - p1.lat) * 180) / Math.PI +
                90;

            style += `transform:rotate(${angle}deg);`;
        } else {
            style += 'display: none;';
        }
        return style;
    }

    private getSitePopup(info: any[]) {
        let html: string = '';
        info.map(v => {
            html += `${v}</br>`;
            return html;
        });
        return html;
    }

    private getVehiclePopup(info: any) {
        let html: string = '';
        info.name.map((v: any) => {
            html += `${v}</br>`;
            return html;
        });
        return html;
    }
}
